import React from 'react';
import PropTypes from 'prop-types';
import { valueOrPlaceholder } from 'helpers/string_helpers';
import PhoneList from '../phone_list';

export default class PersonBody extends React.Component {
  static propTypes = {
    crmEmail: PropTypes.string,
    record: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
  }

  handleEmail = (e) => {
    e.preventDefault();
    const { crmEmail, record } = this.props;

    let url = `mailto:${record.email}`;
    if (crmEmail) {
      url += `?bcc=${encodeURIComponent(crmEmail)}`;
    }
    window.open(url);
  };

  render = () => {
    const { record, user } = this.props;

    return (
      <div className="px-6 py-4">
        <div className="row gy-2">
          <div className="col-md-6">
            <div className="fw-bold">Company</div>
            <div className="text-truncate">
              {valueOrPlaceholder(record.companyName)}
            </div>
          </div>

          <div className="col-md-6">
            <div className="fw-bold">Role</div>
            <div className="text-truncate">
              {valueOrPlaceholder(record.jobTitle)}
            </div>
          </div>

          <div className="col-md-6">
            <div className="fw-bold">Email</div>
            <a className="text-truncate clickable" onClick={this.handleEmail}>
              {valueOrPlaceholder(record.email)}
            </a>
          </div>

          <div className="col-md-12">
            <div className="fw-bold">Phone</div>
            <div className="text-truncate">
              <PhoneList name={record.name} phoneNumbers={record.phoneNumbers} user={user}/>
            </div>
          </div>

          <div className="col-md-12">
            <div className="fw-bold">Notes</div>
            <div className="text-truncate">
              {valueOrPlaceholder(record.personalNotes)}
            </div>
          </div>
        </div>
      </div>
    );
  };
}
